import { useState } from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { CustomIcon } from '$src/components/CustomIcon';

import './index.less';

export default function WarningWithAction({ description, title, action, onClick, shouldRenderAction, shouldRenderLoading, ...props }) {
  const [loading, setLoading] = useState(false);

  const handleOnClick = async (click) => {
    if (shouldRenderLoading) {
      setLoading(true);
      await click();
      setLoading(false);
    } else {
      click();
    }
  };

  return (
    <div className="warning-with-action__container" data-testid="warning">
      <CustomIcon className="warning-with-action__icon" type="regular" name="warning.svg" />
      <div className="warning-with-action__content" data-testid={props['data-testid']}>
        <h3 className="warning-with-action__title"> {title} </h3>
        <p className="warning-with-action__subline"> {description} </p>
        {shouldRenderAction && (
          <Button type="primary" size="large" onClick={() => handleOnClick(onClick)} loading={loading} danger>
            {action}
          </Button>
        )}
      </div>
    </div>
  );
}

WarningWithAction.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  shouldRenderAction: PropTypes.bool,
  shouldRenderLoading: PropTypes.bool,
  'data-testid': PropTypes.string,
};

WarningWithAction.defaultProps = {
  shouldRenderAction: true,
  shouldRenderLoading: false,
};
